// src/pages/Users/Galleries/components/SkeletonAlbumCard.jsx

import React from "react";

export default function SkeletonAlbumCard() {
  return (
    <div className="overflow-hidden rounded-[2rem] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900">
      <div className="aspect-[16/12] animate-pulse bg-slate-200 dark:bg-slate-800 sm:aspect-[16/11]" />

      <div className="space-y-3 p-5">
        <div className="h-4 w-full animate-pulse rounded-full bg-slate-200 dark:bg-slate-800" />
        <div className="h-4 w-5/6 animate-pulse rounded-full bg-slate-200 dark:bg-slate-800" />
        <div className="h-4 w-2/3 animate-pulse rounded-full bg-slate-200 dark:bg-slate-800" />

        <div className="mt-4 flex gap-2">
          {Array.from({ length: 4 }).map((_, index) => (
            <div
              key={index}
              className="h-14 flex-1 animate-pulse rounded-2xl bg-slate-200 dark:bg-slate-800"
            />
          ))}
        </div>

        <div className="grid grid-cols-2 gap-3 pt-2">
          <div className="h-12 animate-pulse rounded-2xl bg-slate-200 dark:bg-slate-800" />
          <div className="h-12 animate-pulse rounded-2xl bg-slate-200 dark:bg-slate-800" />
        </div>
      </div>
    </div>
  );
}